module.exports = __webpack_public_path__ + "static/DSC05616-626667ab2fc0bdf85a630fe34bfa4667.jpg";